module.exports = __webpack_public_path__ + "img/ezbill-1.01672ef7.png";